import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

export function Sections({children}) {
  return <div className='notebookSections'>{children}</div>;
}

Sections.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};
